/* hemlund cart upsell — fed by Shopify's own catalog data (same collection → recommendations → fallback collection); nothing fabricated. */
(function () {
  'use strict';
  var GENERIC = ["all","frontpage","rea","nyheter","bastsaljare","bestsaljare-hemlund","rum-vardagsrum","rum-sovrum","rum-kok","rum-hall","rum-badrum","rum-utomhus","belysning","textil","dekoration"];
  var FALLBACK = "bestsaljare-hemlund";
  var state = { recs: [], idx: 0, busy: false, key: '' };
  var timer = null;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function box() { return document.getElementById('CartUpsell'); }
  function str(k, d) { var b = box(); return (b && b.dataset[k]) || d; }
  function cents(x) { if (typeof x === 'number') return Math.round(x); if (typeof x === 'string') return x.indexOf('.') > -1 ? Math.round(parseFloat(x) * 100) : parseInt(x, 10) || 0; return 0; }
  /* classic Shopify money formatting driven by shop.money_format (follows the active market currency) */
  function money(c) {
    var fmt = str('moneyFormat', '{{amount_no_decimals}} kr');
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(fmt); var key = m ? m[1] : 'amount';
    function num(v, prec, th, dec) { var n = (v / 100).toFixed(prec); var p = n.split('.'); p[0] = p[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + th); return p.join(dec); }
    var out;
    switch (key) {
      case 'amount_no_decimals': out = num(c, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = num(c, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = num(c, 0, '.', ','); break;
      case 'amount_with_space_separator': out = num(c, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': out = num(c, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': out = num(c, 2, "'", '.'); break;
      default: out = num(c, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, out).replace(/<[^>]*>/g, '');
  }
  function imgUrl(u) { if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=180'; }
  function sellable(p) { return p.variants && p.variants.some(function (v) { return v.available !== false; }); }
  async function collection(handle, inCart) {
    try {
      var r = await fetch(root() + 'collections/' + handle + '/products.json?limit=24');
      if (!r.ok) return [];
      return ((await r.json()).products || []).filter(function (p) { return !inCart.has(p.id) && sellable(p); });
    } catch (e) { return []; }
  }
  async function fetchRecs(productId, inCart) {
    var b = box();
    var handles = ((b && b.dataset.collections) || '').split(',').filter(Boolean);
    var specific = handles.filter(function (h) { return GENERIC.indexOf(h) < 0; });
    var broad = handles.filter(function (h) { return GENERIC.indexOf(h) >= 0 && h !== 'all' && h !== 'frontpage'; });
    var recs = [];
    for (var i = 0; i < specific.length && !recs.length; i++) recs = await collection(specific[i], inCart);
    if (!recs.length) {
      try {
        var r = await fetch(root() + 'recommendations/products.json?product_id=' + productId + '&limit=10&intent=related');
        if (r.ok) recs = ((await r.json()).products || []).filter(function (p) { return !inCart.has(p.id) && p.available !== false; });
      } catch (e) { /* fall through */ }
    }
    for (var j = 0; j < broad.length && !recs.length; j++) recs = await collection(broad[j], inCart);
    if (!recs.length && FALLBACK) recs = await collection(FALLBACK, inCart);
    return recs;
  }
  function render() {
    var b = box(); if (!b || !state.recs.length) return;
    var p = state.recs[state.idx];
    var img = b.querySelector('.cart-upsell__img'), imglink = b.querySelector('.cart-upsell__imglink');
    var title = b.querySelector('.cart-upsell__title'), price = b.querySelector('.cart-upsell__price'), add = b.querySelector('.cart-upsell__add');
    var url = root().replace(/\/$/, '') + '/products/' + p.handle;
    var raw = p.featured_image || (p.images && p.images[0]) || '';
    var image = typeof raw === 'string' ? raw : (raw && raw.src) || '';
    img.src = imgUrl(image); img.alt = p.title; imglink.href = url;
    title.textContent = p.title; title.href = url;
    var avail = (p.variants || []).filter(function (v) { return v.available !== false; });
    var basePrice = avail.length ? avail[0].price : (p.price != null ? p.price : (p.variants && p.variants[0] && p.variants[0].price));
    var cmp = avail.length ? avail[0].compare_at_price : null;
    price.innerHTML = money(cents(basePrice)) + (cmp && cents(cmp) > cents(basePrice) ? ' <s>' + money(cents(cmp)) + '</s>' : '');
    var sel = b.querySelector('.cart-upsell__variant');
    if (!avail.length) { add.textContent = str('view', 'View'); add.onclick = function () { window.location.href = url; }; if (sel) sel.hidden = true; }
    else if (avail.length === 1) { if (sel) sel.hidden = true; add.textContent = str('add', 'Add'); add.onclick = function () { addToCart(avail[0].id, add); }; }
    else {
      sel.innerHTML = avail.map(function (v) { return '<option value="' + v.id + '" data-price="' + cents(v.price) + '" data-cmp="' + cents(v.compare_at_price || 0) + '">' + String(v.title).replace(/</g, '&lt;') + '</option>'; }).join('');
      sel.hidden = false;
      sel.onchange = function () { var o = sel.options[sel.selectedIndex]; var pc = parseInt(o.getAttribute('data-price'), 10), cc = parseInt(o.getAttribute('data-cmp'), 10); price.innerHTML = money(pc) + (cc > pc ? ' <s>' + money(cc) + '</s>' : ''); };
      add.textContent = str('add', 'Add'); add.onclick = function () { addToCart(parseInt(sel.value, 10), add); };
    }
    var prev = b.querySelector('[data-dir="-1"]'), next = b.querySelector('[data-dir="1"]');
    prev.disabled = state.recs.length < 2; next.disabled = state.recs.length < 2;
    prev.onclick = function () { state.idx = (state.idx - 1 + state.recs.length) % state.recs.length; render(); };
    next.onclick = function () { state.idx = (state.idx + 1) % state.recs.length; render(); };
  }
  async function addToCart(variantId, btn) {
    if (state.busy) return; state.busy = true;
    if (btn) { btn.textContent = '…'; btn.disabled = true; }
    try {
      var r = await fetch(root() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }) });
      if (r.ok) await refreshDrawerSections();
    } finally { state.busy = false; if (btn) { btn.disabled = false; btn.textContent = str('add', 'Add'); } }
  }
  async function refreshDrawerSections() {
    var r = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
    var data = await r.json();
    var parse = function (html, sel) { return new DOMParser().parseFromString(html, 'text/html').querySelector(sel); };
    var drawer = document.getElementById('CartDrawer'); var nd = parse(data['cart-drawer'], '#CartDrawer');
    if (drawer && nd) drawer.innerHTML = nd.innerHTML;
    var bubble = document.getElementById('cart-icon-bubble'); var nb = parse(data['cart-icon-bubble'], '.shopify-section');
    if (bubble && nb) bubble.innerHTML = nb.innerHTML;
    var cd = drawer && drawer.closest('cart-drawer'); if (cd) cd.classList.remove('is-empty');
    try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS === 'object') { var c = await (await fetch(root() + 'cart.js')).json(); publish(PUB_SUB_EVENTS.cartUpdate, { source: 'upx-upsell', cartData: c }); } } catch (e) {}
    refresh();
  }
  async function refresh() {
    var b = box(); if (!b) return;
    try {
      var cart = await (await fetch(root() + 'cart.js')).json();
      var bar = document.querySelector('.cart-shipbar');
      if (!cart.items.length) { b.hidden = true; if (bar) bar.style.display = 'none'; return; }
      if (bar) bar.style.display = '';
      var inCart = new Set(cart.items.map(function (i) { return i.product_id; }));
      var key = Array.from(inCart).sort().join(',');
      if (key !== state.key) { state.recs = (await fetchRecs(cart.items[0].product_id, inCart)).slice(0, 8); state.key = key; state.idx = 0; }
      if (!state.recs.length) { b.hidden = true; return; }
      render(); b.hidden = false;
    } catch (e) { b.hidden = true; }
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 200); }
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('CartDrawer'); if (!drawer) return;
    new MutationObserver(function (muts) { var b = box(); if (muts.some(function (m) { return !b || !b.contains(m.target); })) schedule(); }).observe(drawer, { childList: true, subtree: true });
    refresh();
  });
})();
